module.exports = __webpack_public_path__ + "img/muslim-teacher.8eb8fdfb.jpg";